import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/ivan/Dev/projects/BB/bigbang-base/layouts/default.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/home/ivan/Dev/projects/BB/nuxt-base/layouts/blank.vue").then(m => m.default || m)),
  bot: defineAsyncComponent(() => import("/home/ivan/Dev/projects/BB/nuxt-base/layouts/bot.vue").then(m => m.default || m))
}